import { Button, Spinner } from "@instructure/ui";
import { t } from "i18next";

const Footer = ({ handleClose, handleSave, loadingSaveSettings }) => {
  return (
    <>
      <Button margin="0 small 0 0" onClick={handleClose}>
        {t("global.cancel")}
      </Button>

      <Button
        color="primary"
        type="submit"
        onClick={handleSave}
        disabled={loadingSaveSettings}
      >
        {loadingSaveSettings ? (
          <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
        ) : (
          t("global.save")
        )}
      </Button>
    </>
  );
};

export default Footer;
